import { SVG, SVGProps } from './svg'

export function IconSettings(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path
        fillRule="evenodd"
        d="M8.8 5h11.7c.3 0 .5.2.5.5v1c0 .3-.2.5-.5.5H8.8a3 3 0 110-2zM5 6a1 1 0 102 0 1 1 0 00-2 0zm15.5 5h-5.7a3 3 0 00-5.6 0H3.5c-.3 0-.5.2-.5.5v1c0 .3.2.5.5.5h5.7a3 3 0 005.6 0h5.7c.3 0 .5-.2.5-.5v-1c0-.3-.2-.5-.5-.5zM11 12a1 1 0 102 0 1 1 0 00-2 0zm7 3a3 3 0 00-2.8 2H3.5c-.3 0-.5.2-.5.5v1c0 .3.2.5.5.5h11.7a3 3 0 102.8-4zm-1 3a1 1 0 102 0 1 1 0 00-2 0z"
      />
    </SVG>
  )
}
